import React from "react";
import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { isAuthenticated, isAuthenticating } from "../../redux/slice";
import LoadingScreen from "../../../../shared/components/Loading";

const RequireAuth = () => {
    const authenticated = useSelector(isAuthenticated);
    const authenticating = useSelector(isAuthenticating);

    if (authenticating) return <LoadingScreen />;

    return authenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default RequireAuth;
